import { EnvelopeIcon, PhoneIcon, UserIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";

const ContactUs = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: ''
    });

    const handleInputChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
    };

    return <section id="contact" className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className=" flex justify-end">
                <div className="bg-white rounded-2xl p-8 shadow-[0px_8px_30px_0px_#80808033] relative w-full lg:w-[80%]">
                    <div className="text-white w-full lg:w-[50%] py-10 lg:py-0 lg:h-[85%] flex flex-col justify-center items-center text-center bg-[#08206B] p-8 lg:absolute top-[7.5%] left-[-180px]">
                        <h2 className="text-4xl lg:text-5xl font-bold mb-10">Contact Us</h2>
                        <p className="text-white mb-8 text-lg">
                            Lorem Ipsum is simply dummy text of the printing industry. Proin vulputate metus in commodo iaculis.
                        </p>

                        <div className="space-y-6 w-full">
                            <div className="flex items-center space-x-4 bg-white text-black rounded-lg p-4">
                                <div className="w-6 h-6 text-[#56B22F]">
                                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                </div>
                                <span>kaziagency.co.uk@gmail.com</span>
                            </div>

                            <div className="flex items-center space-x-4 bg-white text-black rounded-lg p-4">
                                <div className="w-6 h-6 text-[#56B22F]">
                                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                    </svg>
                                </div>
                                <span>+44 1234567890</span>
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-end">
                        <form onSubmit={handleSubmit} className="space-y-6 mt-4 lg:mt-0 w-full lg:w-[60%] py-8">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="border border-gray-300 rounded-lg flex items-center pr-3">
                                    <div className="block text-sm font-medium text-gray-700">
                                        <UserIcon className="w-6 h-6 ml-2 text-[#56B22F]" />
                                    </div>
                                    <input
                                        type="text"
                                        name="firstName"
                                        placeholder="First Name*"
                                        value={formData.firstName}
                                        onChange={handleInputChange}
                                        className="w-full px-2 py-3 focus:ring-2 focus:ring-transparent focus:border-transparent"
                                        required
                                    />
                                </div>
                                <div className="border border-gray-300 rounded-lg flex items-center pr-3">
                                    <div className="block text-sm font-medium text-gray-700">
                                        <UserIcon className="w-6 h-6 ml-2 text-[#56B22F]" />
                                    </div>
                                    <input
                                        type="text"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleInputChange}
                                        className="w-full px-2 py-3 focus:ring-2 focus:ring-transparent focus:border-transparent"
                                        required
                                        placeholder="Last Name*"
                                    />
                                </div>
                            </div>

                            <div className="border border-gray-300 rounded-lg flex items-center pr-3">
                                <div className="block text-sm font-medium text-gray-700">
                                    <EnvelopeIcon className="w-6 h-6 ml-2 text-[#56B22F]" />
                                </div>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    className="w-full px-2 py-3 focus:ring-2 focus:ring-transparent focus:border-transparent"
                                    required
                                    placeholder="Email Address*"
                                />
                            </div>

                            <div className="border border-gray-300 rounded-lg flex items-center pr-3">
                                <div className="block text-sm font-medium text-gray-700">
                                    <PhoneIcon className="w-6 h-6 ml-2 text-[#56B22F]" />
                                </div>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    placeholder="Phone Number"
                                    className="w-full px-2 py-3 focus:ring-2 focus:ring-transparent focus:border-transparent"
                                />
                            </div>

                            <div className="border border-gray-300 rounded-lg flex items-center pr-1">
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    rows={4}
                                    placeholder="Message"
                                    className="w-full px-2 py-3 rounded-lg focus:ring-2 focus:ring-transparent focus:border-transparent"
                                ></textarea>
                            </div>

                            <button
                                type="submit"
                                className="w-full bg-[#56B22F] text-white py-3 rounded-lg font-semibold hover:bg-[#4a9c28] transition-colors"
                            >
                                Submit
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>;
};

export default ContactUs;
